module.exports = __webpack_public_path__ + "img/rzdt.b7fe58d2.png";